import request from '@/utils/request'
// import axios from "axios";
// import { addUrlPerFix } from "@/utils";


// apis/wlyy/cc/manager/queryCreateCommodity
export function queryCreateCommodity(data) {
  return request({
    url: "/apis/sra/cc/users/signup/queryCreateCommodity",
    method: "post",
    data
  });
}

export function getQryMatSubCatalog(data) {
  return request({
    url: "/apis/sra/cc/users/signup/queryClassifyCode",
    method: "post",
    data
  });
}

export function searchCate(data) {
  return request({
    url: "/apis/sra/cc/users/signup/qrySpuCategoryByName",
    method: "post",
    data
  });
}
// 税率
export function getTaxRate(data) {
  return request({
    url: "/apis/sra/cc/users/signup/queryTaxOptions",
    method: "post",
    data
  });
}

// 铺货列表
export function getLogisticsGoodsInfo(data) {
  return request({
    url: "/apis/sra/cc/users/signup/toEditLogisticsCommodity", // 后端接口
    method: "post",
    data
  });
}
// 铺货查询供货商下拉列表
export function qrySupplierByShop(data) {
  return request({
    url: "/apis/sra/cc/users/signup/qrySupplierByShop", // 后端接口
    method: "post",
    data
  });
}
//新查看地址信息接口
export function qryAddressOfFourth(data) {
  return request({
    url: "/apis/sra/cc/users/signup/qryAddressOfFourth",
    method: "post",
    data
  });
}

//选择路线地址
export function qryAreaAddressLoginByEmmc(data) {
  return request({
    url: "apis/sra/cc/users/signup/qryAreaAddressLoginByEmmc",
    
    method: "post",
    data
  });
}


// 物资类别数据-basa全量
export function qryMatCatery100001Tree(data) {
  return request({
    url: "/apis/sra/basic/users/signup/qryMatCatery100001Tree",
    method: "post",
    data
  });
}


// 表
export function queryTaxCodeList(data) {
  return request({
    url: "/apis/sra/cc/users/signup/queryTaxCodeList",
    method: "post",
    data
  });
}

// 树
export function queryTaxCodeTree(data) {
  return request({
    url: "/apis/sra/cc/users/signup/queryTaxCodeTree",
    method: "post",
    data
  });
}

// 铺货
export function createLogisticsCommodity(data) {
  return request({
    url: "apis/sra/cc/users/signup/createLogisticsCommodity",
    method: "post",
    data
  });
}
// 铺货编辑
export function modifyLogisticsCommodity(data) {
  return request({
    url: "apis/sra/cc/users/signup/modifyLogisticsCommodity",
    method: "post",
    data
  });
}

export function qryShopDetailByPhone(data) {
  return request({
    url: "/apis/sra/spc/users/signup/qryShopDetailByPhone",
    method: "post",
    data
  });
}


export function queryShopAnnualFeeOrderPage(data) {
  return request({
    url: "/apis/sra/oc/users/signup/queryShopAnnualFeeOrderPage",
    method: "post",
    data
  });
}

// 审批详情
export function approvalDetail(data) {
  return request({
    url: "/apis/sra/wfc/users/signup/v1/list",
    method: "post",
    data
  });
}


// 查询是否有铺货中的信息
export function queryCreatingLogisticsCommodity(data) {
  return request({
    url: "/apis/sra/cc/users/signup/queryCreatingLogisticsCommodity", // 后端接口
    method: "post",
    data
  });
}
// 基本信息
export function queryBaseInfo(data) {
  return request({
    url: "/apis/sra/cc/users/signup/queryBaseInfo", // 后端接口
    method: "post",
    data
  });
}
//物流销售信息
export function queryLogisticsSaleInfo(data) {
  return request({
    url: "/apis/sra/cc/users/signup/queryLogisticsSaleInfo", // 后端接口
    method: "post",
    data
  });
}
// 查看商品信息以及售后服务信息
export function queryGoodInfoAndSaleAfter(data) {
  return request({
    url: "/apis/sra/cc/users/signup/queryGoodInfoAndSaleAfter", // 后端接口
    method: "post",
    data
  });
}

// 联采公对公提交
export function billPay(data) {
  return request({
    url: "/apis/sra/bill/users/signup/billPay",
    method: "post",
    data
  });
}
// 联采微信支付二维码
export function queryPingAnPayUrl(data) {
  return request({
    url: "/apis/sra/pay/users/signup/queryPingAnPayUrl",
    method: "post",
    data
  });
}
//  联采微信支付状态查询
export function query(data) {
  return request({
    url: "/apis/sra/pay/users/signup/query",
    method: "post",
    data
  });
}

// 联采会员订单下单
export function zoneMemberSubmit(data) {
  return request({
    url: "/apis/sra/oc/users/signup/zoneMemberSubmit",
    method: "post",
    data
  });
}
// 联采会员查询
export function checkJointProcurementZoneMember(data) {
  return request({
    url: "/apis/sra/spc/users/signup/zone/checkJointProcurementZoneMember",
    method: "post",
    data
  });
}